module.exports = __webpack_public_path__ + "static/leading-voice-in-radio-bfc8e1cb4cb74e7e23a9ff590eae2581.jpg";